import { createSignal, type JSX } from 'solid-js'

type Theme = 'auto' | 'dark' | 'light'
const THEMES = new Set<Theme>(['auto', 'dark', 'light'])

function readInitial(): Theme {
  if (typeof document === 'undefined') return 'auto'
  const t = document.documentElement.getAttribute('data-theme') as Theme | null
  return t && THEMES.has(t) ? t : 'auto'
}

export default function ThemeToggle(): JSX.Element {
  const [theme, setTheme] = createSignal<Theme>(readInitial())

  const apply = (t: Theme) => {
    setTheme(t)
    document.documentElement.setAttribute('data-theme', t)
    try {
      localStorage.setItem('ccxp-theme', t)
    } catch {}
  }

  return (
    <select
      class="theme-select"
      aria-label="Theme"
      value={theme()}
      onChange={(e) => apply(e.currentTarget.value as Theme)}
    >
      <option value="auto">Auto</option>
      <option value="dark">Dark</option>
      <option value="light">Light</option>
    </select>
  )
}
